import { TextField } from '@material-ui/core';
import styled from 'styled-components';

export const Input = styled(TextField)`
  width: 100%;
`;